// extracted by mini-css-extract-plugin
export var button = "_ci-4";
export var hasDarkBackground = "_ci-7";
export var hasLightBackground = "_ci-6";
export var iconWrapper = "_ci-0";
export var large = "_ci-2";
export var medium = "_ci-1";
export var small = "_ci-5";
export var xsmall = "_ci-3";